<template>
  <div class="checkout-tile">
    <div class="input-type-radio">
      <input
        @click="setSelected()"
        type="radio"
        :id="inputId"
        :name="inputName"
        :value="option.id"
        :checked="option.selected"
      />
      <component
        v-bind:is="optionTileType"
        :option="option"
        :methodId="methodId"
        :isInFlyin="isInFlyin"
      />
    </div>
  </div>
</template>
<script src="./delivery-option-tile.js"/>
